export default function StaticPinnedColumns() {
  return (
    <table>
      <tbody>
        <tr>
          <th colSpan={2}>
            <span className="pinned-table-header">Inside Circumference</span>
          </th>
        </tr>
        <tr>
          <th style={{ width: '88' }}>IN</th>
          <th style={{ width: '88' }}>MM</th>
        </tr>

        <tr>
          <td>1.74</td>
          <td>44.2</td>
        </tr>
        <tr>
          <td>1.77</td>
          <td>44.8</td>
        </tr>
        <tr>
          <td>1.79</td>
          <td>45.5</td>
        </tr>
        <tr>
          <td>1.82</td>
          <td>46.1</td>
        </tr>
        <tr>
          <td>1.84</td>
          <td>46.8</td>
        </tr>
        <tr>
          <td>1.87</td>
          <td>47.4</td>
        </tr>
        <tr>
          <td>1.89</td>
          <td>48</td>
        </tr>
        <tr>
          <td>1.92</td>
          <td>48.7</td>
        </tr>
        <tr>
          <td>1.94</td>
          <td>49.3</td>
        </tr>
        <tr>
          <td>1.97</td>
          <td>50</td>
        </tr>
        <tr>
          <td>1.99</td>
          <td>50.6</td>
        </tr>
        <tr>
          <td>2.02</td>
          <td>51.2</td>
        </tr>
        <tr>
          <td>2.04</td>
          <td>51.9</td>
        </tr>
        <tr>
          <td>2.07</td>
          <td>52.5</td>
        </tr>
        <tr>
          <td>2.09</td>
          <td>53.1</td>
        </tr>
        <tr>
          <td>2.12</td>
          <td>53.8</td>
        </tr>
        <tr>
          <td>2.14</td>
          <td>54.4</td>
        </tr>
        <tr>
          <td>2.17</td>
          <td>55.1</td>
        </tr>
        <tr>
          <td>2.19</td>
          <td>55.7</td>
        </tr>
        <tr>
          <td>2.22</td>
          <td>56.3</td>
        </tr>
        <tr>
          <td>2.24</td>
          <td>57</td>
        </tr>
        <tr>
          <td>2.27</td>
          <td>57.6</td>
        </tr>
        <tr>
          <td>2.29</td>
          <td>58.3</td>
        </tr>
        <tr>
          <td>2.32</td>
          <td>58.9</td>
        </tr>
        <tr>
          <td>2.34</td>
          <td>59.5</td>
        </tr>
        <tr>
          <td>2.37</td>
          <td>60.2</td>
        </tr>
        <tr>
          <td>2.39</td>
          <td>60.8</td>
        </tr>
        <tr>
          <td>2.42</td>
          <td>61.4</td>
        </tr>
        <tr>
          <td>2.44</td>
          <td>62.1</td>
        </tr>
        <tr>
          <td>2.47</td>
          <td>62.7</td>
        </tr>
        <tr>
          <td>2.49</td>
          <td>63.4</td>
        </tr>
        <tr>
          <td>2.52</td>
          <td>64</td>
        </tr>
        <tr>
          <td>2.54</td>
          <td>64.6</td>
        </tr>
        <tr>
          <td>2.57</td>
          <td>65.3</td>
        </tr>
        <tr>
          <td>2.59</td>
          <td>65.9</td>
        </tr>
        <tr>
          <td>2.62</td>
          <td>66.6</td>
        </tr>
        <tr>
          <td>2.65</td>
          <td>67.2</td>
        </tr>
        <tr>
          <td>2.68</td>
          <td>68.1</td>
        </tr>
        <tr>
          <td>2.71</td>
          <td>68.5</td>
        </tr>
        <tr>
          <td>2.72</td>
          <td>69.1</td>
        </tr>
        <tr>
          <td>2.75</td>
          <td>69.7</td>
        </tr>
      </tbody>
    </table>
  );
}
